import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import _ from 'lodash';

const INITIAL_STATE = {
  'loadingInvoices': false,
  'loadingBoxesVerified': false,
  'closingInvoice': false,
  'listInvoices': [],
  'boxesVerifiedList': [],
  'boxesVerifiedListByPage': [],
  'pageSize': 20,
  'pageNumber': 0,
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

function removeInvoiceFromList(list, invoice) {
  const newList = [...list];

  return _.remove(newList, function(item) {
    return item.invoice !== invoice;
  });
}

export const close = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PENDING_INVOICES_TO_BIN]: (state, action) => ({
      ...state,
      'loadingInvoices': true,
    }),
    [ActionTypes.FETCHED_PENDING_INVOICES_TO_BIN]: (state, action) => ({
      ...state,
      'loadingInvoices': false,
      'listInvoices': action.response.data,
    }),
    [ActionTypes.FETCHED_PENDING_INVOICES_TO_BIN_FAILED]: (state, action) => ({
      ...state,
      'loadingInvoices': false,
      'listInvoices': [],
    }),
    [ActionTypes.VERIFYING_INVOICE]: (state, action) => ({
      ...state,
      'loadingBoxesVerified': true,
    }),
    [ActionTypes.VERIFIED_INVOICE]: (state, action) => ({
      ...state,
      'loadingBoxesVerified': false,
      'boxesVerifiedList': action.response.data,
      'boxesVerifiedListByPage': [...getPage(action.response.data, 0, state.pageSize)],
    }),
    [ActionTypes.VERIFIED_INVOICE_FAILED]: (state, action) => ({
      ...state,
      'loadingBoxesVerified': false,
      'boxesVerifiedList': [],
      'boxesVerifiedListByPage': [],
    }),
    [ActionTypes.CHANGE_VERIFY_INVOICE_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'boxesVerifiedListByPage': [...getPage(state.boxesVerifiedList, action.payload, state.pageSize)],
    }),
    [ActionTypes.CHANGE_VERIFY_INVOICE_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'boxesVerifiedListByPage': [...getPage(state.boxesVerifiedList, 0, action.payload)],
    }),
    [ActionTypes.CLOSING_INVOICE]: (state, action) => ({
      ...state,
      'closingInvoice': true,
    }),
    [ActionTypes.CLOSED_INVOICE]: (state, action) => ({
      ...state,
      'closingInvoice': false,
      'listInvoices': removeInvoiceFromList(state.listInvoices, action.payload),
      'boxesVerifiedList': [],
      'boxesVerifiedListByPage': [],
      
    }),
    [ActionTypes.CLOSED_INVOICE_FAILED]: (state, action) => ({
      ...state,
      'closingInvoice': false,
    }),
  })(state, action);
};
